import React from 'react';
import ServiceList from '../components/ServiceList';

const ServiceListPage: React.FC = () => <ServiceList />;

export default ServiceListPage;
